import { useAuthedUser } from '../../common/providers/AuthedUserProvider';

export const useRoadmapFeature = () => {
    const user = useAuthedUser();

    // The Money Map feature has three states for a membership:
    // (a) Has Money Map - determined by existence in database
    // (b) *Will* have Money Map - determined by membership created after X date
    // (c) *Maybe will not* get a Money Map - determined by not (a) and not (b)
    // This is represented as a computed property on User
    //
    // The case of (c) applies to some memberships that pre-date Money Maps.
    // For these members, their experience should not be modified, meaning
    // that we would still want to show the legacy Goals content on a tab with
    // the original icon in its original location.
    // At least until they do get a Money Map

    const disableRoadmapFeatures = !user.isRoadmapActive;

    return {
        disableRoadmapFeatures,
    };
};
